function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.056 11.77a8.38 8.38 0 0 1 .282-3.327C1.35 4.99 4.526 2.45 8.292 2.406V.149c0-.126.157-.193.26-.117l4.644 3.413c.076.058.076.174 0 .228l-4.64 3.413c-.107.076-.26.009-.26-.117V4.717a6.08 6.08 0 0 0-5.5 3.726 5.999 5.999 0 0 0 .856 6.122 1.156 1.156 0 0 1-.22 1.657 1.165 1.165 0 0 1-1.602-.224A8.281 8.281 0 0 1 .056 11.77zm13.409-4.335a1.159 1.159 0 0 1 .215-1.657 1.166 1.166 0 0 1 1.603.224 8.238 8.238 0 0 1 1.769 4.228 8.463 8.463 0 0 1-.282 3.327c-1.008 3.458-4.188 5.997-7.954 6.037v2.257c0 .126-.152.193-.26.117l-4.64-3.413c-.076-.054-.076-.17 0-.228l4.645-3.413c.103-.076.26-.009.26.117v2.252c2.476-.035 4.59-1.567 5.5-3.726.34-.81.519-1.71.47-2.66a5.98 5.98 0 0 0-1.326-3.462z"
});

var SvgIconRecycle = function SvgIconRecycle(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon icon-recycle",
    width: 18,
    height: 22,
    fill: "#4859EE",
    viewBox: "0 0 18 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRecycle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-recycle.fa96433a.svg";
export { ForwardRef as ReactComponent };